import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/close.svg'


const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center fixed inset-y-0 right-0 overflow-x-hidden overflow-y-hidden z-50 w-full"
}
const _hoisted_2 = { class: "flex relative w-1/2 h-auto" }
const _hoisted_3 = { class: "flex flex-col bg-white w-full h-auto rounded-2xl shadow p-8" }
const _hoisted_4 = { class: "flex flex-row justify-between mb-8" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-lg" }, "Submit clarification", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = { class: "flex flex-col mb-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "mb-4" }, " Please submit a clarification request if there are any errors in the payroll. We will contact you as soon as possible. ", -1)
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "h-0.5 bg-gray-300 w-full mb-4" }, null, -1)
const _hoisted_13 = { class: "flex flex-row items-center justify-between" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 1,
  class: "bg-black opacity-50 fixed inset-y-0 right-0 z-40 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal = true)),
      class: "btn-outline-sm"
    }, " Submit clarification "),
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal = false))
                }, _hoisted_7)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.message) = $event)),
                    placeholder: "How can we help you?",
                    rows: "4",
                    class: "w-full rounded bg-background p-4 resize-none focus:outline-none"
                  }, null, 512), [
                    [_vModelText, _ctx.message]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => {
                    _ctx.openModal = false;
                    _ctx.message = '';
                  }),
                      class: "rounded-full border-2 border-primary text-primary py-4 px-6"
                    }, " Cancel "),
                    _createElementVNode("button", {
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addComment && _ctx.addComment(...args))),
                      disabled: !_ctx.message,
                      class: "bg-primary rounded-full text-white py-4 px-6 disabled:opacity-50 disabled:cursor-not-allowed"
                    }, " Send request ", 8, _hoisted_14)
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15))
      : _createCommentVNode("", true)
  ]))
}